import React, {Component} from 'react'
import axios from 'axios'
import {Page} from '../components'
import SwitchTab from '../components/wk/WKSwitchTab'
import FreeLectureItemCardView from '../components/freeLecture/FreeLectureItemCardView'
import FreeLectureItemList from '../components/freeLecture/FreeLectureItemList'
import {WKSkeletonScreen} from '../components/wk'
import {browserHistory} from 'react-router'
import FreeLectureCardSkeleton from '../components/freeLecture/FreeLectureCardSkeleton'
import '../css/page/FreeLecturePage.css'

class FreeLecturePage extends Component {

    constructor() {
        super()
        this.getParams = browserHistory.getCurrentLocation().query
        this.selectTab = this.getParams.acquisition;
        this.state = {
            FreeLectureList: [],
            AcquireLectureList:[],
            isFetchAcquire:false,
            tab: 0,
            tabFixed: false
        }
    }

    componentDidMount() {
        if(this.selectTab && this.selectTab == 1) {
            this.setTabIndex(1)
        }
        // 解决返回黑屏的问题
        window.scrollTo(0,1)

        document.title = '赠一得一';
        axios.get('/api/index/recommend', {
            params: {
                type: 'free_zone'
            }
        }).then(res => {
            this.setState({
                FreeLectureList: res.data.data.recommends,
                initializedLectureList: true,
            })
        })
    }

    fetchAcquireLecture() {
        axios.get('/api/freezone/get_accepted_lectures').then((res) => {
            if(res.data.code===0) {
                this.setState({
                    AcquireLectureList: res.data.data.lectures,
                    isFetchAcquire:true,
                    initializedMyLecture:true
                })
            }
        })
    }

    setTabIndex(val) {
        if(val === 1 && !this.state.isFetchAcquire) {
            this.fetchAcquireLecture()
        }
        this.setState({
            tab:val
        })
    }

    render() {
        const {FreeLectureList, AcquireLectureList, initializedLectureList, initializedMyLecture} = this.state;
        return (
            <Page>

                <div className="freeLecturePage">
                    <div className="freeLecturePage-banner" style={{display: this.state.tab !== 0 && 'none'}}>
                        <img src="https://static-cos.lycheer.net/picture/8173011_abb49935ae9624b39fa92d44b6ba9154.jpg" alt=""/>
                    </div>
                    <div className="freeLecture-wrapStyle" style={{display: this.state.tab !== 0 && 'none'}}>
                        {!initializedLectureList ?
                            <FreeLectureCardSkeleton num={6}/>
                            :
                            FreeLectureList.map((item) => {
                                return (
                                    <FreeLectureItemCardView content={item} key={item.id}/>
                                )
                            })
                        }
                    </div>

                    <div className="hasReceiveLectureList" style={{display: this.state.tab !== 1 && 'none'}}>
                        {!initializedMyLecture ?
                            <WKSkeletonScreen num={3}/>
                            :
                            AcquireLectureList.length === 0 ?
                                <div className="ifNoFreeLecture">
                                    <img src="https://static-cos.lycheer.net/picture/8173011_836b7a23a0ad6691509a9b3d33a38e52.jpg" alt=""/>
                                    <p>你还没有获得课程哦 <br/>点击“赠一得一”看看吧 </p>
                                </div>
                                :
                                AcquireLectureList.map((item,index) => {
                                    return (
                                        <FreeLectureItemList maxlLength={AcquireLectureList.length} index={index} content={item} key={item.id}/>
                                    )
                                })
                            }
                    </div>

                    <div className="freeLecture-bottom-menu">
                        <SwitchTab LineLength={20} tabFixed={this.state.tabFixed} tabName={['赠一得一','已获课程']} setTabIndex={val=>this.setTabIndex(val)} isSelectIndex={this.state.tab}/>
                    </div>
                </div>
            </Page>
        )

    }
}

export default FreeLecturePage



// WEBPACK FOOTER //
// ./src/pages/FreeLectureNewPage.js